import type { FC } from 'react';
import { Box, Typography, useTheme } from '@/shared/ui/mui';
import { LoadingSpinner } from './LoadingSpinner';

interface LoadingScreenProps {
  message?: string;
  variant?: 'dots' | 'minimal';
  fullHeight?: boolean;
}

export const LoadingScreen: FC<LoadingScreenProps> = ({
  message,
  fullHeight = true,
}) => {
  const theme = useTheme();

  return (
    <Box
      role="status"
      aria-live="polite"
      aria-busy="true"
      sx={{
        height: fullHeight ? '100vh' : '100%',
        minHeight: fullHeight ? 'auto' : 400,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.palette.background.default,
      }}
    >
      <LoadingSpinner size="large" />
      {message ? (
        <Typography
          variant="body2"
          sx={{
            mt: 2,
            color: theme.palette.text.secondary,
            textAlign: 'center',
          }}
        >
          {message}
        </Typography>
      ) : null}
      {!message ? (
        <Box
          component="span"
          sx={{
            position: 'absolute',
            width: 1,
            height: 1,
            p: 0,
            m: -1,
            overflow: 'hidden',
            clip: 'rect(0 0 0 0)',
            whiteSpace: 'nowrap',
            border: 0,
          }}
        >
          Loading...
        </Box>
      ) : null}
    </Box>
  );
};
